import React from "react";

import bannerImg from "../../assets/img/—Pngtree—young girl with laptop_19496399.png";

import { useGlobalContext } from "../../context/context";
import { Link } from "react-router-dom";

import "./banner.css";
const Banner = () => {
  const { openSidebar } = useGlobalContext();

  return (
    <section className="banner d-flex align-items-center ">
      <div className="bubble-animation">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>

      <div className="container">
        <div className="row">
          <div className="col-md-6 ">
            <h2 className="theme-clr mb-3 fs-5">
              Ekonomski, FON, Saobraćajni
            </h2>
            <h1 className="mb-3 text-capitalize fs-3 fw-bold">
              Priprema studenata za polaganje ispita
            </h1>
            <p className="mb-4 text-muted">
              Od 1999. godine sa vama
            </p>
            
            
              <Link
              className="theme-btn"
              to="courses">
                Pogledaj dostupne kurseve
                </Link>
            
          </div>
          <div className="col-md-6 order-first order-md-last mb-5 mb-md-0">
            <div className="circular-img">
              <img src={bannerImg} alt="banner img" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
